import React from 'react';
import PropTypes from 'prop-types';
import { formatLongToDate, formatLongToDateHM } from '../../helpers/Data'
import { downloadArquivo, downloadComprovanteInscricao, downloadDadosInscricao, downloadBoleto, getInformacoesDeCertificadoDisponivel, consultaCEP, buscaCEP } from '../../view/formulario/actions/FormActions'
import { View, FieldsGroup, FieldDetail, ButtonFields, Progress, Icone, Label, Divider } from 'react-template';
import Certificados from "./Certificados"
import { downloadFileLink } from '../../helpers/Downloads'

class SubscriptionView extends View {
    constructor(props) {
        super(props);
        this.state = {
            cpf: '',
            idSubmissao: '',
            idForm: '',
            tituloFormulario: '',
            descricaoFormulario: '',
            permissaoFormulario: '',
            dataSubmissao: '',
            itensSubmissao: '',
            itensComCertificado: '',
            itensComArquivo: '',
            pesquisa_submissao: true,
            valorBoleto: 0,
            certificadoDisponivel: false,
            statusLoader: false,
        }

        this.changeStatusLoader = this.changeStatusLoader.bind(this)
        this.downloadComprovanteDeInscrição = this.downloadComprovanteDeInscrição.bind(this)
        this.downloadBoleto = this.downloadBoleto.bind(this)
        this.downloadDadosInscricao = this.downloadDadosInscricao.bind(this)
        // this.downloadArquivo = this.downloadArquivo.bind(this)
    }

    componentWillMount() {
        this.setConteudoSubmissao(this.props.submissao);
    }

    setConteudoSubmissao(submissao) {
        let { itensSubmissao, itensComCertificado, itensComArquivo } = this.getItensSubmissao(submissao);

        this.setState({
            cpf: submissao.cpf,
            idSubmissao: submissao.id,
            idForm: submissao.form.id,
            tituloFormulario: JSON.parse(submissao.form.formSchema).schema.title,
            descricaoFormulario: JSON.parse(submissao.form.formSchema).schema.description,
            permissaoFormulario: submissao.form.permissao,
            dataSubmissao: submissao.dataSubmissao,
            itensSubmissao: itensSubmissao,
            itensComCertificado: itensComCertificado,
            itensComArquivo: itensComArquivo,
            pesquisa_submissao: this.props.pesquisa_submissao,
            valorBoleto: submissao.valorBoleto,
        });

        getInformacoesDeCertificadoDisponivel(submissao.id, res => {
            const certificadoDisponivel = res.data
            this.setState({ ...this.state, certificadoDisponivel })
        },
            error => {
                this.notifyError('Erro ao tentar buscar informações de Certificados Disponiveis', '');
            })
    }

    getItensSubmissao(submissao) {
        const itens = JSON.parse(submissao.form.formEditavel).itens
        const formSchema = JSON.parse(submissao.form.formSchema)
        let itensSubmissao = [];
        let itensComCertificado = []
        let itensComArquivo = []
        let dadosFormJson = JSON.parse(submissao.dadosForm.replace(/'/g, '"'));

        for (let itemName in dadosFormJson) {
            // pega o index o item
            var i = itemName.split('_')[1];
            const itemSubmissao = dadosFormJson[itemName];
            const itemTitulo = (formSchema.schema.properties[itemName] !== undefined ? formSchema.schema.properties[itemName].title : 'Questão removida do formulário');

            let tipo = null
            const iFind = itens.find(item => {
                return item.id === parseInt(i, 10)
            })

            if (iFind) tipo = iFind.tipo

            // separa os que tem e não tem certificado
            if (itemTitulo === 'Questão removida do formulário') {
                itensSubmissao.push({ titulo: itemTitulo, resposta: itemSubmissao, tipo });
            } else if ((itens.find(item => item.id + '' === i) !== undefined) && (itens.find(item => item.id === parseInt(i, 10)).certificado)) {
                itensComCertificado.push({ titulo: itemTitulo, resposta: itemSubmissao, itemId: i });
            } else if ((itens.find(item => item.id + '' === i) !== undefined) && itens.find(item => item.id === parseInt(i, 10)).tipo === "arquivo") {
                itensComArquivo.push({ titulo: itemTitulo, resposta: itemSubmissao });
            } else {
                itensSubmissao.push({ titulo: itemTitulo, resposta: itemSubmissao, tipo });
            }
        }
        return { itensSubmissao, itensComCertificado, itensComArquivo };
    }

    imprimirLinhaDeCertificado(resposta, itemId = 0, titulo = '') {
        return (
            <div>
                <b>{resposta}</b> <br />
                <small>{titulo}</small>

                <div>
                    {!this.state.pesquisa_submissao && (
                        this.renderLiberarCertificadoForm(itemId, resposta)
                    )}
                </div>
            </div>
        )
    }

    renderLiberarCertificadoForm(itemId, resposta) {
        const certificadosSemDadosFixos = this.props.certificadosSemDadosFixos
        const index = certificadosSemDadosFixos.indexOf(parseInt(itemId, 10), 0)

        if (index === -1) {
            return (
                <pesquisa_submissao
                    key={Math.random()}
                    idSub={this.state.idSubmissao}
                    idCampo={itemId}
                    resposta={resposta}
                />
            )
        } else {
            return (
                <span>Preencha os dados fixo do Certificado</span>
            )
        }
    }

    hasCertificate(itensComCertificado) {

        return (
            <div className={'m-t p-t'}>

                <Divider>Certificados</Divider>
                <Certificados
                    changeStatusLoader={this.changeStatusLoader}
                    idSubmissao={this.state.idSubmissao}
                    tem_presenca={this.props.tem_presenca}
                    itensComCertificado={itensComCertificado}
                    camposComCertificado={this.props.camposComCertificado}
                    todosModelosDeCertificado={this.props.todosModelosDeCertificado}
                    pesquisa_submissao={this.state.pesquisa_submissao} />


                {/* { this.props.tem_presenca && (
                    this.imprimirLinhaDeCertificado('Certificado do Evento')
                )}
                {
                    itensComCertificado.map(item => (
                        this.imprimirLinhaDeCertificado( item.resposta, item.itemId ,item.titulo)
                    ))
                } */}


            </div>
        )
    }

    hasFiles(itensComArquivo) {
        return [
            <div>
                <Divider>Arquivos</Divider>
                <table className='table-certificado'>
                    <thead>
                        <tr>
                            <th className='p-t'>Titulo</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            itensComArquivo.map(item => {
                                const nome_arquivo = item.resposta
                                return (
                                    <tr>
                                        <td>
                                            <b>{item.titulo}</b> <br />
                                            <small>{nome_arquivo}</small>
                                        </td>
                                        <td>
                                            <ButtonFields button='flat' color='blue' icon='file_download' onClick={() => { this.downloadArquivo(this.state.idForm, this.state.cpf, item.resposta) }} content='Download' tamanho="1.7" />
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        ]
    }

    getContent() {
        if (this.state.pesquisa_submissao) { //Visualização
            return this.getViewContent()
        } else { //Edição
            return this.getEditContent()
        }
    }

    getItemData(item) {
        if (item.tipo === "data") {
            return (
                <FieldDetail width={4} titulo={item.titulo}>{formatLongToDate(item.resposta)}</FieldDetail>
            )
        }

        return (
            <FieldDetail width={4} titulo={item.titulo}>{item.resposta}</FieldDetail>
        )
    }

    changeStatusLoader() {
        this.setState({ statusLoader: !this.state.statusLoader })
    }

    downloadComprovanteDeInscrição() {
        this.changeStatusLoader()
        downloadComprovanteInscricao(this.state.idSubmissao, res => {
            downloadFileLink(res.data, "Comprovante de Inscrição - " + this.state.tituloFormulario)
            this.changeStatusLoader()
        }, error => {
            this.changeStatusLoader()
            this.notifyError('Erro ao realizar Download', '');
        })
    }

    downloadArquivo(idForm, cpf, resposta) {
        this.changeStatusLoader()
        downloadArquivo(idForm, cpf, resposta, res => {
            this.changeStatusLoader()
        }, error => {
            this.changeStatusLoader()
            this.notifyError('Erro ao realizar Download', '');
        })
    }

    // downloadArquivo(nome_arquivo){
    //     this.changeStatusLoader()
    //     downloadArquivo(this.state.idForm, this.state.cpf, item.resposta, res => {
    //         downloadFileLink(res.data, "ARQUIVO - " + nome_arquivo)
    //         this.changeStatusLoader()
    //     }, error => {
    //         this.changeStatusLoader()
    //         this.notifyError('Erro ao realizar Download', '');
    //     })
    // }
    //Retorna o primeiro valor que possui o titulo mencionado
    filtroItemSubmissao( titulo ) {
        return this.state.itensSubmissao.filter(e => {return (e.titulo == titulo) })[0];
    }

    downloadBoleto() {
        this.changeStatusLoader();
        //item de submissao 3 é o CEP;
        let cep = this.filtroItemSubmissao("CEP")["resposta"];
        consultaCEP(
            cep,
            endereco => {
                if (endereco) {
                    endereco["numero"] = this.filtroItemSubmissao("Número")["resposta"]
                    downloadBoleto(this.state.idSubmissao, endereco, res => {
                        downloadFileLink(res.data, "Boleto - " + this.state.tituloFormulario)
                        this.changeStatusLoader()
                    }, error => {
                        this.notifyError('Erro ao realizar Download', '');
                        this.changeStatusLoader()
                    })
                } else {
                    this.notifyWarning("Não foi possível buscar o CEP informado");
                }
            },
            error => {
                buscaCEP(cep, res => {
                    if (res) {
                        let endereco = {};
                        endereco["cep"] = res.data.cep;
                        endereco["logradouro"] = res.data.logradouro;
                        endereco["complemento"] = res.data.complemento;
                        endereco["bairro"] = res.data.bairro;
                        endereco["cidade"] = res.data.localidade;
                        endereco["uf"] = res.data.uf;
                        endereco["numero"] = this.filtroItemSubmissao("Número")["resposta"];
                        downloadBoleto(this.state.idSubmissao, endereco, res => {
                            downloadFileLink(res.data, "Boleto - " + this.state.tituloFormulario)
                            this.changeStatusLoader()
                        }, error => {
                            this.notifyError('Erro ao realizar Download', '');
                            this.changeStatusLoader()
                        })
                    } else {
                        this.notifyWarning("Não foi possível buscar o CEP informado");
                    }

                }, error => {
                    this.notifyWarning("Não foi possivel consultar os serviços de confirmação de CEP, tente novamente mais tarde");
                })
            }
        )

    }

    downloadDadosInscricao() {
        this.changeStatusLoader()
        downloadDadosInscricao(this.state.idSubmissao, res => {
            downloadFileLink(res.data, "Dados da inscrição - " + this.state.tituloFormulario)
            this.changeStatusLoader()
        }, error => {
            this.notifyError('Erro ao realizar Download', '');
            this.changeStatusLoader()
        })
    }

    infoConfirmacaoEmail = () => {
        if (this.props.pesquisa_submissao && this.props.submissao.form.confirmarPorEmail) {
            let statusConfirmacao

            if (new Date().getTime() > this.props.submissao.form.dataLimiteConfirmacaoEmail && !this.props.submissao.confirmadoPorEmail) {
                statusConfirmacao = <span>Data limite para confirmação de email expirou em  {formatLongToDate(this.props.submissao.form.dataLimiteConfirmacaoEmail)}</span>
            } else if (this.props.submissao.confirmadoPorEmail) {
                statusConfirmacao = <span>Inscrição confirmada. Data da confirmação: {formatLongToDateHM(this.props.submissao.dataConfirmacao)}</span>
            } else {
                statusConfirmacao = <span>Aguardando confirmação. Data limite: {formatLongToDate(this.props.submissao.form.dataLimiteConfirmacaoEmail)}</span>
            }

            return (
                <FieldDetail width={6} titulo='Confirmação de Inscrição:'>
                    {statusConfirmacao}
                </FieldDetail>
            )
        }
    }

    abrirPaginaConfirmarEmail = () => {
        const origin = window.location.origin
        const win = window.open(`${origin}/confirmacao/${this.props.submissao.hashConfirmacao}`, "_blank")
        win.focus()
    }

    getViewContent() {
        return (
            <div>
                Descrição: {this.state.descricaoFormulario}
                <p>
                    <FieldDetail width={4} titulo='Data de submissão:'>{formatLongToDate(this.state.dataSubmissao)}</FieldDetail>

                    {this.infoConfirmacaoEmail()}


                    {this.state.valorBoleto > 0 && (
                        <div>
                            <small><b>Valor total da incrição: </b> R$ {this.state.valorBoleto}</small>
                            {this.props.submissao.statusPagamento ? (
                                <Label color='green'>
                                    Pagamento Confirmado
                                </Label>
                            ) : (
                                    <Label color='orange'>
                                        Aguardando Pagamento
                                </Label>
                                )}
                        </div>
                    )}
                </p>
                <div>
                    <div className='btn-comprovante-incricao p-t'>
                        <div>
                            {!(new Date().getTime() > this.props.submissao.form.dataLimiteConfirmacaoEmail) &&
                                this.props.submissao.form.confirmarPorEmail && !this.props.submissao.confirmadoPorEmail && (
                                    <ButtonFields button='flat' color='red' icon='check_circle' onClick={this.abrirPaginaConfirmarEmail} content='Confirmar Inscrição' tamanho="1.7" />
                                )}
                            <ButtonFields button='flat' color='blue' icon='receipt' onClick={this.downloadComprovanteDeInscrição} content='Comprovante de Inscrição' tamanho="1.7" />
                            {this.state.valorBoleto > 0 && (
                                <ButtonFields button='flat' color='green' icon='local_atm' onClick={this.downloadBoleto} content='Gerar Boleto' tamanho="1.7" />
                            )}
                        </div>
                    </div>
                    <Divider className='m-t'> Dados da Submissão </Divider>
                    <FieldsGroup>
                        {this.state.itensSubmissao.map(item => (
                            this.getItemData(item)
                        ))}
                    </FieldsGroup>
                </div>
                <div>
                    {this.state.itensComArquivo.length > 0 &&
                        this.hasFiles(this.state.itensComArquivo)
                    }
                </div>
                <div>
                    {(this.state.itensComCertificado.length > 0 || this.props.tem_presenca) &&
                        this.hasCertificate(this.state.itensComCertificado)
                    }
                </div>
            </div>
        )
    }

    getEditContent() {
        return (
            <div>
                <div>
                    <div className='btn-comprovante-incricao p-t'>
                        <ButtonFields button='flat' color='red' mini title='Download dos dados da inscrição como PDF'
                            onClick={this.downloadDadosInscricao} tamanho="1.7">
                            <Icone icone='file-pdf' size='huge' fontAwesome fab="far" />
                            PDF
                        </ButtonFields>
                    </div>
                    <FieldsGroup>
                        {this.state.itensSubmissao.map(item => (
                            <FieldDetail key={item.titulo} width={4} titulo={item.titulo}>{item.resposta}</FieldDetail>
                        ))}
                    </FieldsGroup>
                </div>
                <div className={'m-t p-t'}>
                    {this.state.itensComArquivo.length > 0 &&
                        this.hasFiles(this.state.itensComArquivo)
                    }
                </div>
                {this.renderCertificate()}
            </div>
        )
    }

    renderCertificate() {
        if (this.state.itensComCertificado.length > 0 || this.props.tem_presenca) {
            return this.hasCertificate(this.state.itensComCertificado);
        }
    }

    render() {
        return (
            <div className='subscription-view'>
                {this.state.statusLoader && <Progress position={'bottom'} />}
                {this.getContent()}
            </div>
        );
    }
}

SubscriptionView.propTypes = {
    submissao: PropTypes.object.isRequired
}

export default SubscriptionView;


// WEBPACK FOOTER //
// ./src/components/view/SubscriptionView.js